// this file is generated by update_shopify_store_data.py at 2026-11-03 20:11:28.044248
var courses = [
    {
        "course_id": "02287349-798B-F111-99B2-005056A7F5E9",
        "course_version": 1,
        "name": "AAENP - ENP Pharmacology Bundle",
        "course_type": 32,
        "author_information": "",
        "description": "Pharmacology credit that reflects how you actually prescribe. The ENP Pharmacology Bundle covers the medication decisions and toxicologic emergencies that define emergency practice \u2014 antibiotic selection, treatment of addiction, envenomation, and the pediatric ingestions that arrive with a frightened parent and a very short window to act. Developed and taught by experts in emergency care, these courses help you meet pharmacology CE requirements with content you will use on your next shift. \r\n\r\n6 Courses Included",
        "learning_objectives_html": "At the conclusion, participants should be able to:",
        "course_outline_html": "",
        "credit_info": "-",
        "categories": [
            {
                "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Emergency Services",
                "is_system_course_category": null
            },
            {
                "course_category_id": "9B623ACF-6516-F111-99A7-005056A7C0C7",
                "course_category_name": "AAENP - ENP Pharmacology Bundle",
                "is_system_course_category": null
            },
            {
                "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                "course_category_name": "Nurse Practitioner",
                "is_system_course_category": null
            },
            {
                "course_category_id": "6BD0D294-CF89-F111-99B9-005056A7EBB6",
                "course_category_name": "AAENP - ENP Pharmacology - Curriculum",
                "is_system_course_category": null
            },
            {
                "course_category_id": "D3F6527A-6516-F111-99A7-005056A7C0C7",
                "course_category_name": "AAENP - American Academy of Emergency Nurse Practitioners",
                "is_system_course_category": null
            },
            {
                "course_category_id": "0CA45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Emergency Medicine",
                "is_system_course_category": null
            },
            {
                "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                "course_category_name": "Acute Care Facility",
                "is_system_course_category": null
            }
        ],
        "ce_accreditation": {
            "accrediting_body_name": null,
            "accreditation_statement": null,
            "course_level_accreditation_statement": null,
            "credit_display_name": null,
            "credit_units": null,
            "credit_unit_display_name": null
        },
        "sub_courses": [
            {
                "course_id": "525EA248-E017-F111-99AB-005056A70840",
                "course_version": 1,
                "name": "Bugs & Drugs: An Antibiotic Update",
                "course_type": 1,
                "author_information": "Michael Gooch, DNP, APRN, CCP, ACNP-BC, FNP-BC, ENP-C",
                "description": "This presentation will provide a review and update on empiric \"bugs and drugs\" commonly encountered in emergency care settings. A brief review of microbiology and the classes of medications and their common side effects and interactions will be reviewed. Using a body system approach, the current recommendations for appropriate empiric agents will be reviewed including ENT, CAP, SSSTI, STI, UTI, viral infections, exposure prophylaxis, and systemic problems such as sepsis. Lastly, the importance of patient education and antibiotic stewardship will be addressed.",
                "learning_objectives_html": "Upon completion of this online activity, the participant should be able to:\r\n<ul>\r\n    <li>Identify the mechanism of actions of the five main categories of antibiotic therapies.</li>\r\n    <li>Describe common adverse drug reactions associated with antimicrobial agents.</li>\r\n    <li>Modify the plan of care to incorporate the appropriate empiric agent based on the presumed site or source of infection.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "9B623ACF-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - ENP Pharmacology Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F55315B0-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7B66D488-1B26-E711-9EDE-005056B14F90",
                        "course_category_name": "Antimicrobials",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "415C7DA9-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - ENP Pharmacology Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5E38CE86-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - ENP Pharmacology - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D3F6527A-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - American Academy of Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "19D918B6-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B8391A67-3160-F111-99AE-005056A7327D",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "BON; BON-CNA",
                    "accreditation_statement": "American Academy of Emergency Nurse Practitioners (AAENP) is an approved continuing education provider through the Alabama Board of Nursing (ABNP#1571, exp 8/2027)",
                    "course_level_accreditation_statement": "",
                    "credit_display_name": "CNE",
                    "credit_units": 1.0,
                    "credit_unit_display_name": "Contact Hour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "788C2C5C-E017-F111-99AB-005056A70840",
                "course_version": 1,
                "name": "Taming the Toxins: Solutions for Ingestions and Exposures",
                "course_type": 1,
                "author_information": "Michael Gooch, DNP, APRN, CCP, ACNP-BC, FNP-BC, ENP-C",
                "description": "Emergency nurse practitioners often manage patients with a variety of exposures and ingestions. These can be accidental or intentional overdoses, resulting in challenging and sometimes unique treatment plans. During this presentation, the typical toxidromes as well as a range of toxins, medications, and substances will be discussed. Newer agents of abuse such as xylazine and new strategies including high dose insulin and intralipid therapy administration will be reviewed.",
                "learning_objectives_html": "Upon completion of this online activity, the participant should be able to:\r\n<ul>\r\n    <li>Identify applicable reversal agents in select toxic ingestions and exposures.</li>\r\n    <li>Recall indications for high dose insulin and intralipid therapy in select toxic emergencies.</li>\r\n    <li>Discuss appropriate ordering, monitoring, and risk assessment associated with reversal agents.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "B1D5F710-EFD0-E511-AEA0-005056B11FFF",
                        "course_category_name": "Gastrointestinal Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "71623ACF-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - OB Emergencies Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D3F6527A-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - American Academy of Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "19D918B6-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B8391A67-3160-F111-99AE-005056A7327D",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5E38CE86-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - ENP Pharmacology - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "415C7DA9-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - ENP Pharmacology Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9B623ACF-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - ENP Pharmacology Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F55315B0-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners - Courses",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "BON; BON-CNA",
                    "accreditation_statement": "American Academy of Emergency Nurse Practitioners (AAENP) is an approved continuing education provider through the Alabama Board of Nursing (ABNP#1571, exp 8/2027)",
                    "course_level_accreditation_statement": "",
                    "credit_display_name": "CNE",
                    "credit_units": 1.0,
                    "credit_unit_display_name": "Contact Hour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "509FB375-E017-F111-99AB-005056A70840",
                "course_version": 1,
                "name": "Pharmacologic Treatment of Crotalid Snakebites",
                "course_type": 1,
                "author_information": "Gordon Worley, MSN, RN, FNP-C, ENP-C, FAWM",
                "description": "This course will examine characteristics of venomous snake bites. Prehospital and ED evaluation and care will be discussed as well as utilization of antivenom.",
                "learning_objectives_html": "Upon completion of this online activity, the participant should be able to:\r\n<ul>\r\n    <li>Recognize and describe the identifying characteristics of venomous snakes native to North America.</li>\r\n    <li>   Describe prehospital and emergency department evaluation and treatment of crotalid snakebite.</li>\r\n    <li>   Discuss antivenom treatment of crotalid envenomation. (Pharm content ~ 0.3 hours)</li>\r\n    <li>   Identify common misconceptions about snake behavior and snakebite treatment.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "415C7DA9-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - ENP Pharmacology Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "02064EC2-15DD-E311-AD18-005056B141CC",
                        "course_category_name": "Medications",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "19D918B6-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9B623ACF-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - ENP Pharmacology Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B8391A67-3160-F111-99AE-005056A7327D",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5E38CE86-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - ENP Pharmacology - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F55315B0-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D3F6527A-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - American Academy of Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "512CB365-6DC3-E911-814D-005056B14D10",
                        "course_category_name": "Injuries",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "BON; BON-CNA",
                    "accreditation_statement": "American Academy of Emergency Nurse Practitioners (AAENP) is an approved continuing education provider through the Alabama Board of Nursing (ABNP#1571, exp 8/2027)",
                    "course_level_accreditation_statement": "",
                    "credit_display_name": "CNE",
                    "credit_units": 0.8,
                    "credit_unit_display_name": "Contact Hour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "4F12A4B3-DE17-F111-99AB-005056A70840",
                "course_version": 1,
                "name": "Pediatric Toxicological Emergencies: I only turned my back for one second!",
                "course_type": 1,
                "author_information": "Michael Schill III, DNP, FNP-BC, ENP-C, CEN, CFRN, MICN",
                "description": "Each day, we are unaware of some dangers around the house. It only takes a moment for a pediatric patient to get into something potentially harmful. We have all heard the phrase from a parent: \"I only turned my back for one second.\" This presentation will provide a review of the most common harmful household items and common medications. Whether you work in the Emergency Department or Urgent Care, this will help to review common signs and symptoms and up-to-date treatment. This interactive case scenario-based presentation will review and discuss pharmacological and non-pharmacological treatment modalities.",
                "learning_objectives_html": "Upon completion of this online activity, the participant should be able to:\r\n<ul>\r\n    <li>Discuss the epidemiology of household ingestions in the pediatric population</li>\r\n    <li>Describe evaluation and management of potentially fatal ingestion of a single prescription medication</li>\r\n    <li>Identify common non-toxic toys that can still be toxic to the pediatric population</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "3CA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Pediatrics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F55315B0-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D3F6527A-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - American Academy of Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E5A9019D-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Pediatric Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8C2AEAC8-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Pediatric Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9B623ACF-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - ENP Pharmacology Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "415C7DA9-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - ENP Pharmacology Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D1051744-2226-E711-9EDE-005056B14F90",
                        "course_category_name": "Pediatric Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "19D918B6-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B8391A67-3160-F111-99AE-005056A7327D",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5E38CE86-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - ENP Pharmacology - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9106255A-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - Pediatric - Courses",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "BON; BON-CNA",
                    "accreditation_statement": "American Academy of Emergency Nurse Practitioners (AAENP) is an approved continuing education provider through the Alabama Board of Nursing (ABNP#1571, exp 8/2027)",
                    "course_level_accreditation_statement": "",
                    "credit_display_name": "CNE",
                    "credit_units": 0.5,
                    "credit_unit_display_name": "Contact Hour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "55C0CA34-E017-F111-99AB-005056A70840",
                "course_version": 1,
                "name": "Addiction & Treatment in the ED",
                "course_type": 1,
                "author_information": "K. Chenin Kenig, RN, MSN, FNP-C",
                "description": "This presentation will describe the role of the hospital emergency department (ED), not simply in emergency treatment of overdose, but as a provider of care for underlying addiction and as a catalyst for change in our approach to drug use as a society.",
                "learning_objectives_html": "Upon completion of this online activity, the participant should be able to:\r\n<ul>\r\n    <li>Understand the Pharmacokinetics of buprenorphine</li>\r\n    <li>Understand Initial dosing, induction of buprenorphine in the ED</li>\r\n    <li>Understand that you can bill for MAT in the ED, G2213</li>\r\n    <li>Be able to understand ways to obtain X-waiver</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "5E38CE86-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - ENP Pharmacology - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "415C7DA9-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - ENP Pharmacology Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "19D918B6-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D3F6527A-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - American Academy of Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B8391A67-3160-F111-99AE-005056A7327D",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "02064EC2-15DD-E311-AD18-005056B141CC",
                        "course_category_name": "Medications",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9B623ACF-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - ENP Pharmacology Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F55315B0-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "1EE81567-9882-E211-B22E-0015171C1A75",
                        "course_category_name": "Substance Abuse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "BON; BON-CNA",
                    "accreditation_statement": "American Academy of Emergency Nurse Practitioners (AAENP) is an approved continuing education provider through the Alabama Board of Nursing (ABNP#1571, exp 8/2027)",
                    "course_level_accreditation_statement": "",
                    "credit_display_name": "CNE",
                    "credit_units": 0.9,
                    "credit_unit_display_name": "Contact Hour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "B2E077CD-DE17-F111-99AB-005056A70840",
                "course_version": 1,
                "name": "Single Dose Killers: Pediatric Toxicology",
                "course_type": 1,
                "author_information": "Micheal Gooch, DNP, APRN, ACNP-BC, FNP-BC, FAANP, FAEN",
                "description": "Toxicological emergencies are commonly encountered in emergency care. Some are more serious than others. In pediatric patients, there are a few substance known as the single dose killers as it only takes a small amount to cause toxicity. This presentation will review these agents, discuss their clinical manifestations, and management priorities to allow emergency NPs to manage these patients more competently.",
                "learning_objectives_html": "Upon completion of this online activity, the participant should be able to:\r\n<ul>\r\n    <li>Identify some of the single dose killers in pediatric toxicology</li>\r\n    <li>Modify management plans to correct toxicities encountered in pediatric toxicology</li>\r\n    <li>Introduce mechanisms for alleviating secondary traumatic stress, compassion fatigue, and burnout among professionals who provide care to critically ill or injured patients.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "512CB365-6DC3-E911-814D-005056B14D10",
                        "course_category_name": "Injuries",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D3F6527A-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - American Academy of Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9B623ACF-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - ENP Pharmacology Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "3CA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Pediatrics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "415C7DA9-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - ENP Pharmacology Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F55315B0-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8C2AEAC8-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Pediatric Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5E38CE86-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - ENP Pharmacology - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E5A9019D-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Pediatric Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9106255A-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - Pediatric - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "19D918B6-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D1051744-2226-E711-9EDE-005056B14F90",
                        "course_category_name": "Pediatric Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B8391A67-3160-F111-99AE-005056A7327D",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "BON; BON-CNA",
                    "accreditation_statement": "American Academy of Emergency Nurse Practitioners (AAENP) is an approved continuing education provider through the Alabama Board of Nursing (ABNP#1571, exp 8/2027)",
                    "course_level_accreditation_statement": "",
                    "credit_display_name": "CNE",
                    "credit_units": 1.0,
                    "credit_unit_display_name": "Contact Hour(s)"
                },
                "sub_courses": []
            }
        ]
    }
];